import { render } from "./RealExamView.vue?vue&type=template&id=1f269ae1&scoped=true"
import script from "./RealExamView.vue?vue&type=script&lang=js"
export * from "./RealExamView.vue?vue&type=script&lang=js"

import "./RealExamView.vue?vue&type=style&index=0&id=1f269ae1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f269ae1"]])

export default __exports__